"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _draftJsCustomStyles = _interopRequireDefault(require("draft-js-custom-styles"));

var _shoutoutThemesEnterprise = require("@shoutout-labs/shoutout-themes-enterprise");

var _FaICIconMap = require("./../../../FaICIconMap");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _createStyles = (0, _draftJsCustomStyles["default"])(['addcolor'], 'CUSTOM_', {}),
    styles = _createStyles.styles;

var colors = ["ONE", "TWO", "THR", "FUR", "FVE", "SIX", "SVN"];

var FontsPicker = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FontsPicker, _PureComponent);

  function FontsPicker() {
    var _this;

    _this = _PureComponent.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "onWindowClick", function () {
      return (// Call `onOverrideContent` again with `undefined`
        // so the toolbar can show its regular content again.
        _this.props.onOverrideContent(undefined)
      );
    });

    _this.onClick = _this.onClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FontsPicker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    setTimeout(function () {
      window.addEventListener('click', _this2.onWindowClick);
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  };

  _proto.onClick = function onClick(e) {
    var _this3 = this;

    e.preventDefault();
    e.stopPropagation();
    var editorState = this.props.getEditorState();
    var newEditorState = styles.addcolor.add(editorState, e.currentTarget.id);
    this.props.onOverrideContent(undefined);
    setTimeout(function () {
      _this3.props.setEditorState(newEditorState);
    });
  };

  _proto.render = function render() {
    var _this4 = this;

    var currentStyle = styles.addcolor.current(this.props.getEditorState()) || "0";
    var selectedTheme = this.props.selectedTheme;
    return /*#__PURE__*/_react["default"].createElement("div", null, colors.map(function (item) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "toolbarButtonWrapper",
        key: item
      }, /*#__PURE__*/_react["default"].createElement("button", {
        id: item,
        onClick: _this4.onClick,
        onMouseDown: _this4.onMouseDown,
        className: "toolbarButton " + (currentStyle === item ? 'active' : '')
      }, /*#__PURE__*/_react["default"].createElement(_shoutoutThemesEnterprise.IcIcon, {
        style: selectedTheme["CUSTOM_ADDCOLOR_" + item],
        icon: _FaICIconMap.faSquareFull
      })));
    }));
  };

  return FontsPicker;
}(_react.PureComponent);

var _default = FontsPicker;
exports["default"] = _default;
module.exports = exports.default;